import { useRef } from 'react';
export function useInitialProgress(isInProgress) {
    const isInitInProgressRef = useRef(isInProgress);
    return isInitInProgressRef.current;
}
